import { createAsyncThunk } from '@reduxjs/toolkit';

import { removeUndefined } from 'commonUtils/removeUndefined';

import { sendSentryClientErrorOnce } from 'shared/lib';

import type { TCreditFormCommonFields, TCreditFormState } from 'entities/creditForm';
import { selectRequiredFieldsForUpdate, formDataToCustomerAdapter } from 'entities/creditForm';
import type { TUserState } from 'entities/user/model/user.selectors';
import { isLoggedSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataApi } from '../model/sendCustomerData.query';

export const sendCustomerDataThunk = createAsyncThunk<
  void,
  Partial<TCreditFormCommonFields>,
  { state: TCreditFormState & TUserState }
>('sendCustomerData/sendCustomerDataThunk', async (payload, { dispatch, getState }) => {
  const isLoggedIn = isLoggedSelector(getState());

  if (!isLoggedIn) {
    return;
  }

  const formFields = { ...selectRequiredFieldsForUpdate(getState()), ...payload };

  // проверяем заполнение обязательных полей, так как без них сохранение будет падать с ошибкой
  if (
    (
      ['fullName', 'birthDate', 'passportNumber', 'passportIssueDate', 'passportIssuedBy', 'unitCode'] as Array<
        Partial<keyof TCreditFormCommonFields>
      >
    ).some((key) => !formFields[key])
  ) {
    return;
  }

  try {
    await dispatch(
      sendCustomerDataApi.endpoints.updateCustomerData.initiate(
        removeUndefined(formDataToCustomerAdapter(formFields), [null, ''], true),
      ),
    ).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendCustomerDataThunk', error);
  }
});
